module.exports = __webpack_public_path__ + "static/img/3602.444ecf5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/extend/3602.png
// module id = BtWh
// module chunks = 94